import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/reminder";
import reminderApis from "src/api/reminder";
import { constants } from "src/constants/common";
import { common } from "src/types/index";

// function* getWaterReminderSaga(action: any) {
//   try {
//     const response = yield call(reminderApis.getReminders, action.payload);
//     yield put(getWaterReminderSuccess(response));
//     resolve(response);
//   } catch (error) {
//     yield put(getWaterReminderError(error));
//   }
// }

const GetReminderSaga = function* GetReminderSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      reminderApis.getReminders,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getReminderSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getReminderError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const CreateReminderSaga = function* CreateReminderSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      reminderApis.createReminder,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.createReminderSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.createReminderError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const UpdateReminderSaga = function* UpdateReminderSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      reminderApis.updateReminder,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.updateReminderSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.updateReminderError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* reminderSaga() {
  yield all([
    takeEvery(actions.createReminderRequest, CreateReminderSaga),
    takeEvery(actions.getReminderRequest, GetReminderSaga),
    takeEvery(actions.updateReminderRequest, UpdateReminderSaga),
  ]);
}
